import { render, staticRenderFns } from "./BackgroundWithOverlay.vue?vue&type=template&id=3680a77b&scoped=true"
import script from "./BackgroundWithOverlay.vue?vue&type=script&lang=js"
export * from "./BackgroundWithOverlay.vue?vue&type=script&lang=js"
import style0 from "./BackgroundWithOverlay.vue?vue&type=style&index=0&id=3680a77b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3680a77b",
  null
  
)

export default component.exports